import { AudienceChannelSourceFilters } from '@/features/broadcasters/types';
import { TableKeyEnum } from '@/hooks/useTableSettingsStore';
import { createTableFiltersState } from '@/utils/table-filters';

export const useAudienceChannelSourcesFilters =
  createTableFiltersState<AudienceChannelSourceFilters>({
    tableKey: TableKeyEnum.AUDIENCE_CHANNEL_SOURCES,
  });
